import { render, staticRenderFns } from "./placard_screen.vue?vue&type=template&id=67143ea5&scoped=true"
import script from "./placard_screen.vue?vue&type=script&lang=js"
export * from "./placard_screen.vue?vue&type=script&lang=js"
import style0 from "./placard_screen.vue?vue&type=style&index=0&id=67143ea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67143ea5",
  null
  
)

export default component.exports